import { render, staticRenderFns } from "./MutualInductionViz.vue?vue&type=template&id=12b9cce8&scoped=true"
import script from "./MutualInductionViz.vue?vue&type=script&lang=js"
export * from "./MutualInductionViz.vue?vue&type=script&lang=js"
import style0 from "./MutualInductionViz.vue?vue&type=style&index=0&id=12b9cce8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9cce8",
  null
  
)

export default component.exports